import { Avatar } from 'components/Avatar';
import { CardRow } from 'components/CardRow';
import { Card } from 'components/Card';
import { ICONS } from 'components/Icon';
import { Txt } from 'components/Txt';
import { View } from 'react-native';
import { theme } from 'lib/theme';

type Props = {
  name: string;
  email: string;
  id: string;
  avatarUrl: string | null;
  onRemovePressed?: (id: string) => void;
};

export const EngageInspectorCard: React.FC<Props> = ({
  name,
  email,
  id,
  avatarUrl,
  onRemovePressed,
}) => {
  return (
    <Card marginHorizontal={false} style={{ flex: 1 }}>
      <CardRow
        key={id}
        onAction={onRemovePressed ? () => onRemovePressed(id) : undefined}
        actionIcon={ICONS.XmarkLight}
      >
        <View
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: theme.paddingHorizontalHalf,
          }}
        >
          <Avatar
            data={
              avatarUrl
                ? {
                    remoteUrl: avatarUrl,
                  }
                : null
            }
            icon={ICONS.UserLight}
            imageBackgroundColor={'#999999'}
            size={48}
            iconPadding={10}
          />
          <View style={{ flex: 1 }}>
            <Txt key="name" weight="medium" numberOfLines={1}>
              {name}
            </Txt>
            <Txt weight="regular" numberOfLines={1}>
              {email}
            </Txt>
          </View>
        </View>
      </CardRow>
    </Card>
  );
};
